<template>
  <v-container class="fill-height" fluid>

    <v-row align="center" justify="center">
      <v-col cols="12" md="4" sm="8">
        <v-card elevation="1" tile>
          <Loader :loading="loading"></Loader>
          <v-img
              class="ma-auto"
              contain
              max-height="150"
              max-width="150"
              src="@/assets/logo.png"
          ></v-img>
          <v-spacer></v-spacer>

          <v-card-text>
            <v-form @submit.prevent="submit">
              <div>
                <v-text-field
                    v-model="manager.email"
                    label="Email"
                    name="login"
                    prepend-icon="mdi-account"
                    type="text"
                    @blur="$v.manager.email.$touch()"
                ></v-text-field>
                <p v-if="!$v.manager.email.email || !$v.manager.email.wbst_suffix" style="color: red;">Please provide a
                  valid email address.</p>
              </div>
              <div>
                <v-text-field
                    id="password"
                    v-model="manager.password"
                    label="Password"
                    name="password"
                    prepend-icon="mdi-lock"
                    type="password"
                    @blur="$v.manager.password.$touch()"
                ></v-text-field>
                <p v-if="!$v.manager.password.minLength" style="color: red;">Passwords must be have at least 8
                  characters.</p>
              </div>

              <!--
                Alerts & Loaders
              -->


              <v-card-actions>
                <v-row justify="space-between">
                  <v-col>
                    <v-btn tilewidth="100%" @click="sign_up">Registration</v-btn>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col>
                    <v-btn tile type="submit" width="100%">Login</v-btn>
                  </v-col>
                </v-row>

              </v-card-actions>
              <v-card-actions>
                <v-dialog v-model="dialogEmail" max-width="600px" persistent>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs"
                           v-on="on"
                           dark
                           tile
                           width="100%"
                           @click="resetByEmail"
                    >Forgot your password?
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">Enter Email</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-form>
                          <v-row>
                            <v-col cols="12">
                              <div>
                                <v-text-field
                                    v-model="resetEmail"
                                    label="Email"
                                    required
                                    type="text"
                                    @blur="$v.resetEmail.$touch()"
                                ></v-text-field>
                                <p v-if="!$v.resetEmail.email || !$v.resetEmail.wbst_suffix" style="color: red;">Please
                                  provide a valid email address.</p>
                              </div>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                          color="blue darken-1"
                          text
                          tile
                          @click="closeEmail"
                      >Cancel
                      </v-btn>
                      <v-btn
                          :disabled="$v.$anyError"
                          color="blue darken-1"
                          text
                          tile
                          @click="sendResetEmail"
                      >Send
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                  <Loader :loading="loadingCreateUpdateDelete"></Loader>
                </v-dialog>
              </v-card-actions>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import {manager_reset_password} from "../../modules/nite_api";
import {required, email, helpers, minLength} from 'vuelidate/lib/validators';
import Loader from "../shared/Loader";
import VueNotifications from "vue-notifications";


//Check if email contains .com or .net
const wbst_suffix = helpers.regex('alpha', /(\.com|\.net)$/);

export default {
  name: "Login",
  components: {
    Loader
  },
  data() {

    return {
      dialogEmail: false,
      resetEmail: '',
      response: null,
      loadingCreateUpdateDelete: false,
      manager: {
        email: '',
        password: ''
      },
    }
  },
  validations: {
    manager: {
      email: {
        required,
        email,
        wbst_suffix
      },
      password: {
        required,
        minLength: minLength(8)
      },
    },
    resetEmail: {
      required,
      email,
      wbst_suffix
    }
  },
  computed: {

    ...mapGetters({

      loading: 'auth/loading'

    })

  },
  methods: {

    ...mapActions({
      sign_in: 'auth/sign_in',

    }),
    ...mapMutations({

      set_loading: 'auth/SET_LOADING'

    }),


    async submit() {
      this.set_loading(true);
      try {

        await this.sign_in(this.manager);
        await this.$router.push('/');


      } catch (e) {
        console.log(e)
      } finally {
        this.set_loading(false);

      }


    },

    sign_up() {

      this.$router.replace('/sign-up');
    },

    resetByEmail() {
      this.dialogEmail = true

    },

    closeEmail() {

      this.dialogEmail = false
      this.$nextTick(() => {
        this.resetEmail = ''

      })

    },
    async sendResetEmail() {
      this.loadingCreateUpdateDelete = true;
      try {
        const response = await manager_reset_password(this.resetEmail);
        this.response = response.status;

        // Success
        console.log(response);
      } catch (error) {
        // Error
        if (error.response) {
          /*
           * The request was made and the server responded with a
           * status code that falls out of the range of 2xx
           */
          console.log(error.response.data);
          console.log(error.response.status);
          this.response = error.response.status;

          console.log(error.response.headers);
        } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          console.log(error.request);

        } else {
          // Something happened in setting up the request and triggered an Error
          console.log('Error', error.message);

        }
        console.log(error.config);
      } finally {
        this.loadingCreateUpdateDelete = false;
        switch (this.response) {
          case 200:
            this.showSuccessMsg({title: 'Success', message: 'An email was sent with a link to reset the password!'});
            break;

          case 400:
            this.showErrorMsg({
              title: 'Oops',
              message: 'Some field is missing or isn\'t correct. Please make the corrections and try again!'
            });
            break;
          case 404:
            this.showErrorMsg({
              title: 'Oops',
              message: 'That account doesn\'t exist! Please try again with the correct email!'
            });
            break;
          case 500:
            this.showErrorMsg({
              title: 'Error',
              message: 'Something went wrong with the request. Please try again later!'
            });
            break;
          default:
            break;
        }
      }
      this.closeEmail()

    },
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: 'Hello there',
      message: 'That\'s the success!'
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: 'Hey you',
      message: 'Here is some info for you'
    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: 'Wow, man',
      message: 'That\'s the kind of warning'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: 'Wow-wow',
      message: 'That\'s the error'
    }

  }
}
</script>

<style scoped>

</style>